<div class="d-flex align-items-center">
  <!-- profile-dropdown.component.html -->
  <!-- Commenting out the notification panel as we don't have the functionality for it yet -->
  <!-- 
  <li>
    <span class="icons" [innerHTML]="notificationIcon"></span>
  </li> 
  -->

  <!-- -------------------- Profile Section ----------------------- -->
  <li>
    <div class="profile position-relative">
      <!-- -------------------- Profile Image and header info -------------------- -->
      <div class="profile-header" (click)="toggleProfileDropdown()">
        <div class="profile-info">
          <span class="profile-name">
            {{ usersData.firstName + ' ' + usersData.lastName | titlecase }} ({{
              userRole || usersData.roles
            }})
          </span>
          <p class="profile-subtext">
            {{ businessData.name }}
          </p>
        </div>

        <img
          alt=""
          class="profile-img"
          [src]="businessData.logoUrl || 'assets/blank-profile-picture.png'"
        />
        <span
          class="dropdown-icon"
          [innerHTML]="chevronIcon"
          [@rotate]="arrowState"
        ></span>
      </div>

      <!-- -------------------- Popover Component ----------------------- -->
      <g99-lib-header-popover
        [usersData]="usersData"
        [businessData]="businessData"
        [userRole]="userRole"
        [profileMenus]="profileMenus"
        [isShowProfileDropdown]="isShowProfileDropdown"
        (profileMenuClick)="onClickProfileMenu($event.route, $event.label)"
      />
    </div>
  </li>
</div>
